import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function DraggableCard({ id, isEditMode, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: !isEditMode });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || 'transform 200ms ease',
    opacity: isDragging ? 0.55 : 1,
    position: 'relative',
    touchAction: isEditMode ? 'none' : 'auto',
    userSelect: 'none',
    zIndex: isDragging ? 999 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      {/* Drag handle overlay — only visible in edit mode */}
      {isEditMode && (
        <div
          {...listeners}
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 10,
            borderRadius: 'inherit',
            cursor: 'grab',
            background: 'transparent',
          }}
        />
      )}

      {/* Edit mode indicator: teal pulsing border */}
      <div style={{
        position: 'absolute',
        inset: 0,
        borderRadius: 'inherit',
        border: isEditMode ? '2px solid rgba(0,229,180,0.6)' : '2px solid transparent',
        transition: 'border-color 0.2s ease',
        pointerEvents: 'none',
        zIndex: 11,
        animation: isEditMode ? 'cardPulse 2s ease infinite' : 'none',
      }} />

      {children}
    </div>
  );
}
